import React from 'react';
import { Container } from 'react-bootstrap';
import styled from '@emotion/styled';

import SectionWrapper from 'components/layout/SectionWrapper';
import Loader from 'components/elements/Loader';
import MessagePageHeader from 'components/messages/MessagePageHeader';
import { useAnnouncements } from 'context/AnnouncementsContext';
import { AnnouncementItem } from 'types/announcement';
import { formatUTCDate } from 'utils/dateTime';

const MessageCard = styled.article`
  border: 1px solid #e0e0e0;
  border-radius: 0.5rem;
  background-color: #fff;
  padding: 1.25rem;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const CardTitle = styled.h2`
  margin: 0 0 0.25rem;
  font-size: 1.125rem;
  font-weight: 700;
  color: #1a2b3c;
`;

const MessageDate = styled.p`
  margin: 0 0 1rem;
  font-size: 0.875rem;
  color: #9ca3af;
`;

const MessageBody = styled.div`
  font-size: 0.9375rem;
  color: #4b5563;
  line-height: 1.6;
  min-width: 0;
  max-width: 100%;

  white-space: normal;
  overflow-wrap: break-word;
  word-break: normal;

  p {
    margin-bottom: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  img {
    display: block;
    max-width: 100%;
    width: auto !important;
    height: auto !important;
    margin: 0.5rem 0;
    object-fit: contain;
  }
`;

const EmptyState = styled.p`
  margin: 0;
  color: #6b7280;
`;

const cleanHtml = (html: string) => html
  .replace(/&nbsp;/g, ' ')
  .replace(/\u00A0/g, ' ');

const renderMessages = (messages: AnnouncementItem[]) => {
  if (messages.length === 0) {
    return <EmptyState>No messages available.</EmptyState>;
  }

  return messages.map((message) => (
    <MessageCard key={message.id}>
      <CardTitle>{message.title}</CardTitle>

      <MessageDate>
        {formatUTCDate(message.createdAt, 'MMMM D, YYYY')}
      </MessageDate>

      <MessageBody
        dangerouslySetInnerHTML={{
          __html: cleanHtml(message.body),
        }}
      />
    </MessageCard>
  ));
};

const UpdatesPage: React.FC = () => {
  const { messages, isLoading } = useAnnouncements();

  return (
    <Container className="my-5 site-content">
      <SectionWrapper>
        <MessagePageHeader
          title="Updates"
          description="Announcements and news related to BCQP."
        />
        {isLoading ? <Loader /> : renderMessages(messages)}
      </SectionWrapper>
    </Container>
  );
};

export default UpdatesPage;
